import { takeLatest, call } from 'redux-saga/effects';
import {
	getTicketReplyListSuccess, getTicketReplyListFail,
	getTicketReplyDetailsSuccess, getTicketReplyDetailsFail,
} from './ticketreplyState';

import createCrudService from '../../services/crudservice';
import { 
	doCrudCall, SAVING_MSG, LOADING_MSG,
	createRecordSuccess,
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/support/tickets');
const redirectData = { route: '/console/ticket-replies', mode: 'list', recordId: 0 };
const modelName = 'Ticket Reply';
const modelId = 'trp_id';

function* getTicketReplyList(data) {
    const { ticketId } = data.payload;
    const childEndpoint = `${ticketId}/ticket-replies`;

    yield doCrudCall(
        () => crudService.getList({}, childEndpoint),
        (response) => {
            const transformedData = {
                data: response,
                current_page: 1,
                per_page: response.length,
                total: response.length
            };
            return getTicketReplyListSuccess(transformedData);
        },
        getTicketReplyListFail,
        null,
        null,
        LOADING_MSG
    );
}

function* getTicketReplyDetails(data) {
	const { ticketId, replyId } = data.payload;
	const childEndpoint = `${ticketId}/ticket-replies`;
	yield doCrudCall(
		() => crudService.getDetails(replyId, childEndpoint), 
		getTicketReplyDetailsSuccess,
		getTicketReplyDetailsFail,
		null,
		null,
		LOADING_MSG
	);
}

function* doTicketReplyCreate(data) {
    const payload = data.payload;
    
    let trp_ticket_id;
    
    if (payload instanceof FormData) {
        trp_ticket_id = payload.get('trp_ticket_id');
        console.log('FormData detected, ticket ID:', trp_ticket_id);
    } else {
        trp_ticket_id = payload.trp_ticket_id;
        console.log('JSON detected, ticket ID:', trp_ticket_id);
    }
    
    if (!trp_ticket_id || trp_ticket_id === 'undefined') {
        console.error('Invalid ticket ID, aborting API call');
        return;
    }
    
    const childEndpoint = `${trp_ticket_id}/ticket-replies`;
    console.log('Child endpoint:', childEndpoint);
    
    yield doCrudCall(
        () => crudService.doCreate(payload, childEndpoint),
        getTicketReplyDetailsSuccess, 
        getTicketReplyDetailsFail,
        null,
        null,
        SAVING_MSG
    );
}


function* ticketReplySaga() {
	yield takeLatest('ticketReply/getTicketReplyList', getTicketReplyList);
	yield takeLatest('ticketReply/getTicketReplyDetails', getTicketReplyDetails);
	yield takeLatest('ticketReply/doTicketReplyCreate', doTicketReplyCreate);
}

export default ticketReplySaga;
